import { MentorServices } from "./service";
import { toast } from "react-toastify";
import {
  COHORT_REQUEST_MENTOR_DASHBOARD,
  DASHBOARD_MENTOR_MYREQUEST,
  DASHBOARD_MENTOR_HOME,
  MENTORSHIP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION_STATUS,
  VIEW_COUNTER_MENTOR_OPTIONS,
  SESSIONS_SUMMARY_DATA, 
  SESSIONS_SUMMARY_POST_DATA,
  SESSIONS_MENTOR_SUMMARY_POST_DATA,
  POST_MENTOR_FEEDBACK,
  GET_MENTOR_FEEDBACK,
  MENTOR_COHORT_APPLICATION_LIST,
  MENTOR_MODULE_COHORT_LIST,
  MENTOR_MODULE_STARTUP_COHORT_LIST,
  MENTOR_MODULE_STARTUP_COHORT_STATUS,
  MENTOR_MODULE_MENTOR_COHORT_STATUS,
  MENTOR_MODULE_STARTUP_COHORT_COUNTER,
  MENTOR_MODULE_MENTOR_COHORT_COUNTER,
  MATCH_COHORT_LIST,
  MATCH_STARTUP_LIST,
  MATCH_MENTOR_LIST,
  MATCH_COHORT_REQUEST,
  MATCH_RESULT_LIST,
  CREATE_COHORT_GROUP_SESSION,
  DELETE_COHORT_GROUP_SESSION,
  DETAILS_COHORT_GROUP_SESSION,
  LIST_COHORT_GROUP_SESSION,
  LIST_SESSION_MEMBER_LIST,
  GROUP_SESSION_CHANGE_STATUS,
  LIST_COHORT_GROUP_SESSION_COUNTER,
  COHORT_SESSION_INVITATION_LIST,
  COHORT_SESSION_GIVE_FEEDBACK,
  COHORT_SESSION_VIEW_FEEDBACK,
  COHORT_SESSION_NOTES_GIVE_FEEDBACK,
  COHORT_SESSION_NOTES_VIEW_FEEDBACK,
  COHORT_GROUP_SESSION_HOURS,
  COHORT_GROUP_SESSION_HOURS_FILTER,
  POST_COHORT_PROGRAM_SPOTLIGHT,
  COHORTS_COMMON_DASHBOARD,
  COHORTS_DISCUSSION_LIST,
  COHORTS_DISCUSSION_POST,
  COHORTS_DISCUSSION_POST_COMMENT,
  COHORTS_DISCUSSION_COMMENT_LIST,
  COHORTS_DISCUSSION_POST_LIKE,
  COHORTS_COMMENT_POST_LIKE,
  COHORTS_DISCUSSION_POST_UNLIKE,
  COHORTS_COMMENT_POST_UNLIKE,
  COHORTS_THREAD_REMOVE_POST,
  COHORTS_COMMENT_REMOVE_POST,
  COHORTS_COMMENT_REPLY_POST,
  COHORTS_COMMENT_REPLY_LIST,
  COHORT_DASHBOARD_ACTIVITY,
  COHORT_DASHBOARD_STARTUP_COUNTER,
  COHORT_DASHBOARD_MENTORS_COUNTER,
} from "../../../../common/constants/actionConstants";
import swal from "sweetalert";
import { isLoading } from "../../../../common/dependencies/action/action";


export const getCohortMentorList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataList(params).then((data) => {
    const { getCohortRequest } = data;
    
    if (getCohortRequest) {
      dispatch({
        type: COHORT_REQUEST_MENTOR_DASHBOARD,
        payload: getCohortRequest,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataList(params) {
  const getCohortRequest = await MentorServices.getCohortRequest(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getCohortRequest,
  };
}

export const getMentorMyRequest = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    const { DashboardMentorMyRequestList } = data;
    if (DashboardMentorMyRequestList) {
      dispatch({
        type: DASHBOARD_MENTOR_MYREQUEST,
        payload: DashboardMentorMyRequestList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getMentorHome = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataMentorHomeList(params).then((data) => {
    const { DashboardMentorHomeList } = data;
    if (DashboardMentorHomeList) {
      dispatch({
        type: DASHBOARD_MENTOR_HOME,
        payload: DashboardMentorHomeList,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindData(params) {
  const DashboardMentorMyRequestList =
    await MentorServices.dashboardMentorMyrequest().catch((e) => {
      return { data: [], status: false };
    });
  return { DashboardMentorMyRequestList };
}

async function getBindDataMentorHomeList(params) {

  if(params.id==="" ||params.id===null){
    // alert(params.id)
  }else{
    const DashboardMentorHomeList =
    await MentorServices.dashboardMentorHome(params).catch((e) => {
      return { data: {}, status: false };
    });
    return { DashboardMentorHomeList };
  }

}
export const getMentorApplicationStatus = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindStatus(params).then((data) => {
    const { MentorApplicationStatus } = data;
    if (MentorApplicationStatus) {
      dispatch({
        type: MENTORSHIP_APPLICATION,
        payload: MentorApplicationStatus,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindStatus(params) {
  const MentorApplicationStatus =
    await MentorServices.setMentorApplicationStatus().catch((e) => {
      return { data: [], status: false };
    });
  return { MentorApplicationStatus };
}

export const getMentorStartUpApplicationList = (params) => (dispatch) => {
  // dispatch(isLoading(true));
  return getBindApplicationList(params).then((data) => {
    const { MentorApplicationList } = data;
    if (MentorApplicationList) {
      dispatch({
        type: MENTORSHIP_STARTUP_APPLICATION,
        payload: MentorApplicationList,
      });
    }
    // dispatch(isLoading(false));
  });
};

async function getBindApplicationList(params) {
  const MentorApplicationList =
    await MentorServices.getStartUpAppListMentorDash(params).catch((e) => {
      return { data: [], status: false };
    });
  return { MentorApplicationList };
}

export const setMentorStartUpStatus = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindApplicationStatus(params).then((data) => {
    const { MentorApplicationStatus } = data;
    if (MentorApplicationStatus) {
      dispatch({
        type: MENTORSHIP_STARTUP_APPLICATION_STATUS,
        payload: MentorApplicationStatus,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindApplicationStatus(params) {
  const MentorApplicationStatus =
    await MentorServices.setStartUpAppStatus(params).catch((e) => {
      return { data: [], status: false };
    });
  return { MentorApplicationStatus };
}

export const getCountersMentorList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCountersMentorList(params).then((data) => {
    const { getCountersMentorListData } = data;
    
    if (getCountersMentorListData) {
      dispatch({
        type: VIEW_COUNTER_MENTOR_OPTIONS,
        payload: getCountersMentorListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataCountersMentorList(params) {

  const getCountersMentorListData =
  await MentorServices.getCountersMentorList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  getCountersMentorListData
  };
}

export const getMentorCohortApplicationList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCohortMentorList(params).then((data) => {
    const { cohortMentorListData } = data;
    
    if (cohortMentorListData) {
      dispatch({
        type: MENTOR_COHORT_APPLICATION_LIST,
        payload: cohortMentorListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataCohortMentorList(params) {

  const cohortMentorListData =
  await MentorServices.getMentorCohortApplicationList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  cohortMentorListData
  };
}

export const getSessionSummaryData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindDataSessionSummary(params).then((data) => {
    const { getSummaryData } = data;
    
    if (getSummaryData) {
      dispatch({
        type: SESSIONS_SUMMARY_DATA,
        payload: getSummaryData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataSessionSummary(params) {

  const getSummaryData =
  await MentorServices.getSummaryData(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  getSummaryData,
  };
}
export const postSessionSummaryData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindDataSessionSummary(params).then((data) => {
    const { postSummaryData } = data;
    
    if (postSummaryData) {
      dispatch({
        type: SESSIONS_SUMMARY_POST_DATA,
        payload: postSummaryData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindDataSessionSummary(params) {

  const postSummaryData =
  await MentorServices.postSummaryData(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postSummaryData,
  };
}

export const postMentorFeedback = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMentorFeedback(params).then((data) => {
    const { postMentorFeedbackData } = data;
    
    if (postMentorFeedbackData) {
      dispatch({
        type: POST_MENTOR_FEEDBACK,
        payload: postMentorFeedbackData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMentorFeedback(params) {

  const postMentorFeedbackData =
  await MentorServices.postMentorFeedback(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMentorFeedbackData,
  };
}

export const getMentorFeedback = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindMentorFeedback(params).then((data) => {
    const { getMentorFeedbackData } = data;
    
    if (getMentorFeedbackData) {
      dispatch({
        type: GET_MENTOR_FEEDBACK,
        payload: getMentorFeedbackData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindMentorFeedback(params) {

  const getMentorFeedbackData =
  await MentorServices.getMentorFeedback(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  getMentorFeedbackData,
  };
}
export const postMentorSessionMinutes = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMentorSessionMinutes(params).then((data) => {
    const { postMentorSessionMinutesData } = data;
    
    if(postMentorSessionMinutesData.success === true && postMentorSessionMinutesData.data === "Session MOM Summary submitted successfully")
    {
        swal({
          title: "Thank You",
          text: `Session Notes Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        })
    }
    else{
      swal({
        title: "Info!",
        text: `Session Notes has not been submitted.          File Size can not be greater than 2MB`,
        icon: "info",
        // timer: 1500,
        // buttons: false,
      })
    }
    if (postMentorSessionMinutesData) {
      dispatch({
        type: SESSIONS_MENTOR_SUMMARY_POST_DATA,
        payload: postMentorSessionMinutesData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMentorSessionMinutes(params) {

  const postMentorSessionMinutesData =
  await MentorServices.postMentorSessionData(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMentorSessionMinutesData,
  };
}
export const postMentorModuleCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMentorModuleCohort(params).then((data) => {
    const { postMentorCohortData } = data;
    
    if (postMentorCohortData) {
      // window.location.reload();
      dispatch({
        type: MENTOR_MODULE_COHORT_LIST,
        payload: postMentorCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMentorModuleCohort(params) {

  const postMentorCohortData =
  await MentorServices.getMentorModuleCohortList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMentorCohortData,
  };
}
export const postMentorModuleStartupCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMentorModuleStartupCohort(params).then((data) => {
    const { postMentorCohortStartupData } = data;
    
    if (postMentorCohortStartupData) {
      dispatch({
        type: MENTOR_MODULE_STARTUP_COHORT_LIST,
        payload: postMentorCohortStartupData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMentorModuleStartupCohort(params) {

  const postMentorCohortStartupData =
  await MentorServices.getMentorModuleStartupCohortList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMentorCohortStartupData,
  };
}
export const postStatusMentorCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindStatusMentorCohort(params).then((data) => {
    const { postStatusMentorCohortData } = data;
    
    if (postStatusMentorCohortData) {
      dispatch({
        type: MENTOR_MODULE_MENTOR_COHORT_STATUS,
        payload: postStatusMentorCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindStatusMentorCohort(params) {

  const postStatusMentorCohortData =
  await MentorServices.setMentorModuleMentorCohortStatus(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postStatusMentorCohortData,
  };
}
export const postStatusStartupCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindStatusStartupCohort(params).then((data) => {
    const { postStatusStartupCohortData } = data;
    
    if (postStatusStartupCohortData) {
      dispatch({
        type: MENTOR_MODULE_STARTUP_COHORT_STATUS,
        payload: postStatusStartupCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindStatusStartupCohort(params) {

  const postStatusStartupCohortData =
  await MentorServices.setMentorModuleStartupCohortStatus(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postStatusStartupCohortData,
  };
}
export const postCounterMentorCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCounterMentorCohort(params).then((data) => {
    const { postCounterMentorCohortData } = data;
    
    if (postCounterMentorCohortData) {
      dispatch({
        type: MENTOR_MODULE_MENTOR_COHORT_COUNTER,
        payload: postCounterMentorCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCounterMentorCohort(params) {

  const postCounterMentorCohortData =
  await MentorServices.setMentorModuleMentorCohortStatus(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCounterMentorCohortData,
  };
}
export const postCounterStartupCohort = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCounterStartupCohort(params).then((data) => {
    const { postCounterStartupCohortData } = data;
    
    if (postCounterStartupCohortData) {
      dispatch({
        type: MENTOR_MODULE_STARTUP_COHORT_COUNTER,
        payload: postCounterStartupCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCounterStartupCohort(params) {

  const postCounterStartupCohortData =
  await MentorServices.getMentorModuleMentorCohortCounter(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCounterStartupCohortData,
  };
}
export const matchTableCohortList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMatchTableCohortList(params).then((data) => {
    const { postMatchTableCohortListData } = data;
    
    if (postMatchTableCohortListData) {
      dispatch({
        type: MATCH_COHORT_LIST,
        payload: postMatchTableCohortListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMatchTableCohortList(params) {

  const postMatchTableCohortListData =
  await MentorServices.getMatchCohortList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMatchTableCohortListData,
  };
}
export const matchTableStartupList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMatchTableStartupList(params).then((data) => {
    const { postMatchTableStartupListData } = data;
    
    if (postMatchTableStartupListData) {
      dispatch({
        type: MATCH_STARTUP_LIST,
        payload: postMatchTableStartupListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMatchTableStartupList(params) {

  const postMatchTableStartupListData =
  await MentorServices.getMatchStartupList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMatchTableStartupListData,
  };
}
export const matchTableMentorList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMatchTableMentorList(params).then((data) => {
    const { postMatchTableMentorListData } = data;
    
    if (postMatchTableMentorListData) {
      dispatch({
        type: MATCH_MENTOR_LIST,
        payload: postMatchTableMentorListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMatchTableMentorList(params) {

  const postMatchTableMentorListData =
  await MentorServices.getMatchMentorList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMatchTableMentorListData,
  };
}
export const postMatchTableRequest = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMatchTableRequest(params).then((data) => {
    const { postMatchTableRequestData } = data;
    
    if(postMatchTableRequestData.success === true) {
   swal({
          title: "Success!",
          text: postMatchTableRequestData?.data,
          icon: "success",
          timer: 2500,
          // buttons: false,
        });
    }
    else {
   swal({
          title: "Info!",
          text: postMatchTableRequestData?.errors[0]?.message,
          icon: "info",
          timer: 2500,
          // buttons: false,
        });
    }
      //   if (
      //   cohortMatchRequest.errors !== undefined &&
      //   cohortMatchRequest.errors !== null &&
      //   cohortMatchRequest.errors !== "" &&
      //   cohortMatchRequest?.errors?.length > 0
      // ) {
     
      // } else if (
      //   cohortMatchRequest?.length > 0 &&
      //   cohortMatchRequest?.data !== undefined &&
      //   cohortMatchRequest?.data !== null
      // ) {
     
      // }
    if (postMatchTableRequestData) {
      dispatch({
        type: MATCH_COHORT_REQUEST,
        payload: postMatchTableRequestData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMatchTableRequest(params) {

  const postMatchTableRequestData =
  await MentorServices.getMatchCreateRequest(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMatchTableRequestData,
  };
}
export const getmatchTableList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindMatchTableList(params).then((data) => {
    const { postMatchTableListData } = data;
    
    if (postMatchTableListData) {
      dispatch({
        type: MATCH_RESULT_LIST,
        payload: postMatchTableListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindMatchTableList(params) {

  const postMatchTableListData =
  await MentorServices.getMatchResultList(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postMatchTableListData,
  };
}


export const createGroupSession = (params,status) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCreateGroupSession(params).then((data) => {
    const { postCreateGroupSessionData } = data;
    
    if(postCreateGroupSessionData.success === true)
    {

    dispatch(isLoading(false));
        swal({
          title: "Thank You",
          text: `Group Session ${status === "created" ? "Created": "Updated"} Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        })
    }
    else{

    dispatch(isLoading(false));
      swal({
        title: "Service Unavailable",
        text: `Group Session has not been created`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      })
    }
    if (postCreateGroupSessionData) {
      dispatch({
        type: CREATE_COHORT_GROUP_SESSION,
        payload: postCreateGroupSessionData,
      });
    }
  });
};
async function postBindCreateGroupSession(params) {

  const postCreateGroupSessionData =
  await MentorServices.getCreateCohortGroupSession(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCreateGroupSessionData,
  };
}


export const deleteGroupSession = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindDeleteGroupSession(params).then((data) => {
    const { postDeleteGroupSessionData } = data;
    
    if (postDeleteGroupSessionData) {
      dispatch({
        type: DELETE_COHORT_GROUP_SESSION,
        payload: postDeleteGroupSessionData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindDeleteGroupSession(params) {

  const postDeleteGroupSessionData =
  await MentorServices.getDeleteCohortGroupSession(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postDeleteGroupSessionData,
  };
}


export const detailsGroupSession = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindDetailsGroupSession(params).then((data) => {
    const { postDetailsGroupSessionData } = data;
    
    if (postDetailsGroupSessionData) {
      dispatch({
        type: DETAILS_COHORT_GROUP_SESSION,
        payload: postDetailsGroupSessionData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindDetailsGroupSession(params) {

  const postDetailsGroupSessionData =
  await MentorServices.getDetailsCohortGroupSession(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postDetailsGroupSessionData,
  };
}
export const listGroupSession = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindListGroupSession(params).then((data) => {
    const { postListGroupSessionData } = data;
    
 
    if (postListGroupSessionData) {
      dispatch({
        type: LIST_COHORT_GROUP_SESSION,
        payload: postListGroupSessionData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindListGroupSession(params) {

  const postListGroupSessionData =
  await MentorServices.getListCohortGroupSession(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postListGroupSessionData,
  };
}
export const invitedSessionMembersList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindInvitedSessionMembersList(params).then((data) => {
    const { invitedSessionMembersListData } = data;
    
    if (invitedSessionMembersListData) {
      dispatch({
        type: LIST_SESSION_MEMBER_LIST,
        payload: invitedSessionMembersListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindInvitedSessionMembersList(params) {

  const invitedSessionMembersListData =
  await MentorServices.getListSessionMembers(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  invitedSessionMembersListData,
  };
}
export const statusGroupSession = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindstatusGroupSession(params).then((data) => {
    const { postStatusGroupSession } = data;
    
    if(postStatusGroupSession.success === true)
    {
        swal({
          title: "Thank You",
          text: `Cohort Group Session Status Updated Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        })
    }
    else{
      swal({
        title: "Info!",
        text: `Cohort Group Session Status Was Not Updated`,
        icon: "info",
        // timer: 1500,
        // buttons: false,
      })
    }
    if (postStatusGroupSession) {
      dispatch({
        type: GROUP_SESSION_CHANGE_STATUS,
        payload: postStatusGroupSession,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindstatusGroupSession(params) {

  const postStatusGroupSession =
  await MentorServices.updateSessionStatus(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postStatusGroupSession,
  };
}

export const listGroupSessionCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindListGroupSessionCounter(params).then((data) => {
    const { postListGroupSessionCounterData } = data;
    
 
    if (postListGroupSessionCounterData) {
      dispatch({
        type: LIST_COHORT_GROUP_SESSION_COUNTER,
        payload: postListGroupSessionCounterData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindListGroupSessionCounter(params) {

  const postListGroupSessionCounterData =
  await MentorServices.getListCohortGroupSessionCounters(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postListGroupSessionCounterData,
  };
}
// 


export const listCohortInvitation = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindListCohortInvitation(params).then((data) => {
    const { postListCohortInvitation } = data;
    
 
    if (postListCohortInvitation) {
      dispatch({
        type: COHORT_SESSION_INVITATION_LIST,
        payload: postListCohortInvitation,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindListCohortInvitation(params) {

  const postListCohortInvitation =
  await MentorServices.getListCohortInvitation(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postListCohortInvitation,
  };
}

export const cohortSessionGiveFeedBack = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortSessionGiveFeedBack(params).then((data) => {
    const { postCohortSessionGiveFeedBackData } = data;
    
    if(postCohortSessionGiveFeedBackData.success === true)
    {
        swal({
          title: "Thank You",
          text: `Session Feedback Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        })
    }
    else{
      swal({
        title: "Info!",
        text: `Session Feedback has not been Submitted`,
        icon: "info",
        // timer: 1500,
        // buttons: false,
      })
    }
    if (postCohortSessionGiveFeedBackData) {
      dispatch({
        type: COHORT_SESSION_GIVE_FEEDBACK,
        payload: postCohortSessionGiveFeedBackData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortSessionGiveFeedBack(params) {

  const postCohortSessionGiveFeedBackData =
  await MentorServices.giveCohortSessionFeedBack(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortSessionGiveFeedBackData,
  };
}

export const cohortSessionViewFeedBack = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortSessionViewFeedBack(params).then((data) => {
    const { postCohortSessionViewFeedBackData } = data;
    
 
    if (postCohortSessionViewFeedBackData) {
      dispatch({
        type: COHORT_SESSION_VIEW_FEEDBACK,
        payload: postCohortSessionViewFeedBackData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortSessionViewFeedBack(params) {

  const postCohortSessionViewFeedBackData =
  await MentorServices.viewCohortSessionFeedBack(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortSessionViewFeedBackData,
  };
}


export const cohortSessionNotesGiveFeedBack = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortSessionNotesGiveFeedBack(params).then((data) => {
    const { postCohortNotesSessionGiveFeedBackData } = data;
    
    if(postCohortNotesSessionGiveFeedBackData.success === true)
    {
        swal({
          title: "Thank You",
          text: `Session Notes Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        })
    }
    else{
      swal({
        title: "Info!",
        text: `Session Notes has not been Submitted`,
        icon: "info",
        // timer: 1500,
        // buttons: false,
      })
    }
    if (postCohortNotesSessionGiveFeedBackData) {
      dispatch({
        type: COHORT_SESSION_NOTES_GIVE_FEEDBACK,
        payload: postCohortNotesSessionGiveFeedBackData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortSessionNotesGiveFeedBack(params) {

  const postCohortNotesSessionGiveFeedBackData =
  await MentorServices.giveCohortSessionNotesFeedBack(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortNotesSessionGiveFeedBackData,
  };
}

export const cohortSessionNotesViewFeedBack = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortSessionNotesViewFeedBack(params).then((data) => {
    const { postCohortSessionNotesViewFeedBackData } = data;
    
 
    if (postCohortSessionNotesViewFeedBackData) {
      dispatch({
        type: COHORT_SESSION_NOTES_VIEW_FEEDBACK,
        payload: postCohortSessionNotesViewFeedBackData.data,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortSessionNotesViewFeedBack(params) {

  const postCohortSessionNotesViewFeedBackData =
  await MentorServices.viewCohortSessionNotesFeedBack(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortSessionNotesViewFeedBackData,
  };
}


export const cohortGroupSessionHours = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortGroupSessionHours(params).then((data) => {
    const { postCohortGroupSessionHoursData } = data;
    
 
    if (postCohortGroupSessionHoursData) {
      dispatch({
        type: COHORT_GROUP_SESSION_HOURS,
        payload: postCohortGroupSessionHoursData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortGroupSessionHours(params) {

  const postCohortGroupSessionHoursData =
  await MentorServices.getCohortGroupSessionHours(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortGroupSessionHoursData,
  };
}


export const cohortGroupSessionHoursFilter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortGroupSessionHoursFilter(params).then((data) => {
    const { postCohortGroupSessionHoursFilterData } = data;
    
 
    if (postCohortGroupSessionHoursFilterData) {
      dispatch({
        type: COHORT_GROUP_SESSION_HOURS_FILTER,
        payload: postCohortGroupSessionHoursFilterData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortGroupSessionHoursFilter(params) {

  const postCohortGroupSessionHoursFilterData =
  await MentorServices.getCohortGroupSessionHoursFilter(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortGroupSessionHoursFilterData,
  };
}

export const cohortProgramSpotLight = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortProgramSpotLight(params).then((data) => {
    const { postBindCohortProgramSpotLightData } = data;
    if(postBindCohortProgramSpotLightData?.success){
      toast.success( `${cohort_name} ${params?.spotlight ? "added to" :  "removed from"} Spotlight.`, {
      position: "top-right",
      autoClose: 5000,
    });
    }
    else{
      toast.error( `Server error. Please try again after sometime.`, {
        position: "top-right",
        autoClose: 5000,
      });
    }
    if (postBindCohortProgramSpotLightData) {
      dispatch({
        type: POST_COHORT_PROGRAM_SPOTLIGHT,
        payload: postBindCohortProgramSpotLightData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortProgramSpotLight(params) {

  const postBindCohortProgramSpotLightData =
  await MentorServices.postCohortSpotlightAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortProgramSpotLightData,
  };
  
}

export const cohortCommonListDashboard = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortCommonListDashboard(params).then((data) => {
    const { postCohortCommonListData } = data;
    if (postCohortCommonListData) {
      dispatch({
        type: COHORTS_COMMON_DASHBOARD,
        payload: postCohortCommonListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortCommonListDashboard(params) {

  const postCohortCommonListData =
  await MentorServices.postCohortCommonAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortCommonListData,
  };
}



export const cohortCreateDiscussionPost = (params,actionType) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortCreateDiscussionPost(params).then((data) => {
    const { postCohortCreateDiscussionPost } = data;
    if (postCohortCreateDiscussionPost) {
      dispatch({
        type: COHORTS_DISCUSSION_POST,
        payload: postCohortCreateDiscussionPost,
      });
       if(postCohortCreateDiscussionPost?.errors?.length == 0)
       {
      swal({
        title: "Thank You",
        text: `Thread ${actionType == "Edit" ? "Edited" : "Created"} Successfully`,
        icon: "success",
        // timer: 1500,
        // buttons: false,
      });
       }
       else 
       {
        swal({
          title: "Error",
          text: postCohortCreateDiscussionPost?.errors[0]?.message,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
       }
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortCreateDiscussionPost(params) {

  const postCohortCreateDiscussionPost =
  await MentorServices.postCohortThreadAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortCreateDiscussionPost,
  };
}



export const cohortDiscussionList = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortDiscussionList(params).then((data) => {
    const { postBindCohortDiscussionListData } = data;
    if (postBindCohortDiscussionListData) {
      dispatch({
        type: COHORTS_DISCUSSION_LIST,
        payload: postBindCohortDiscussionListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortDiscussionList(params) {

  const postBindCohortDiscussionListData =
  await MentorServices.postCohortThreadListAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortDiscussionListData,
  };
}
export const cohortDiscussionCommentsList = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortDiscussionCommentsList(params).then((data) => {
    const { postBindCommentsListData } = data;
    if (postBindCommentsListData) {
      dispatch({
        type: COHORTS_DISCUSSION_COMMENT_LIST,
        payload: postBindCommentsListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortDiscussionCommentsList(params) {

  const postBindCommentsListData =
  await MentorServices.postCohortThreadCommentsListAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCommentsListData,
  };
}
export const cohortDiscussionAddComment = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortAddComment(params).then((data) => {
    const { postBindAddCommentData } = data;
    if (postBindAddCommentData) {
      dispatch({
        type: COHORTS_DISCUSSION_POST_COMMENT,
        payload: postBindAddCommentData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortAddComment(params) {

  const postBindAddCommentData =
  await MentorServices.postCohortThreadCommentAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindAddCommentData,
  };
}


export const cohortDiscussionPostLikeToggle = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortDiscussionPostLikeToggle(params).then((data) => {
    const { postBindcohortDiscussionPostLikeToggleData } = data;
    if (postBindcohortDiscussionPostLikeToggleData) {
      dispatch({
        type: COHORTS_DISCUSSION_POST_LIKE,
        payload: postBindcohortDiscussionPostLikeToggleData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortDiscussionPostLikeToggle(params) {

  const postBindcohortDiscussionPostLikeToggleData =
  await MentorServices.postCohortLikeThreadAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindcohortDiscussionPostLikeToggleData,
  };
}


export const cohortCommentPostLikeToggle = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortCommentPostLikeToggle(params).then((data) => {
    const { postBindcohortCommentPostLikeToggleData } = data;
    if (postBindcohortCommentPostLikeToggleData) {
      dispatch({
        type: COHORTS_COMMENT_POST_LIKE,
        payload: postBindcohortCommentPostLikeToggleData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortCommentPostLikeToggle(params) {

  const postBindcohortCommentPostLikeToggleData =
  await MentorServices.postCohortLikeCommentAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindcohortCommentPostLikeToggleData,
  };
}


export const cohortDiscussionPostRemoveLike = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortDiscussionPostRemoveLike(params).then((data) => {
    const { postBindcohortDiscussionPostRemoveLikeData } = data;
    if (postBindcohortDiscussionPostRemoveLikeData) {
      dispatch({
        type: COHORTS_DISCUSSION_POST_UNLIKE,
        payload: postBindcohortDiscussionPostRemoveLikeData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortDiscussionPostRemoveLike(params) {

  const postBindcohortDiscussionPostRemoveLikeData =
  await MentorServices.postCohortUnLikeThreadAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindcohortDiscussionPostRemoveLikeData,
  };
}


export const cohortCommentPostRemoveLike = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindcohortCommentPostUnLikeToggle(params).then((data) => {
    const { postBindcohortCommentPostUnLikeToggleData } = data;
    if (postBindcohortCommentPostUnLikeToggleData) {
      dispatch({
        type: COHORTS_COMMENT_POST_UNLIKE,
        payload: postBindcohortCommentPostUnLikeToggleData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindcohortCommentPostUnLikeToggle(params) {

  const postBindcohortCommentPostUnLikeToggleData =
  await MentorServices.postCohortUnLikeCommentAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindcohortCommentPostUnLikeToggleData,
  };
}

export const cohortThreadRemovePost = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortThreadRemovePost(params).then((data) => {
    const { postBindCohortThreadRemovePostData } = data;
    if (postBindCohortThreadRemovePostData) {
      dispatch({
        type: COHORTS_THREAD_REMOVE_POST,
        payload: postBindCohortThreadRemovePostData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortThreadRemovePost(params) {

  const postBindCohortThreadRemovePostData =
  await MentorServices.postCohortThreadRemoveAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortThreadRemovePostData,
  };
}



export const cohortCommentRemovePost = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortCommentRemovePost(params).then((data) => {
    const { postBindCohortCommentRemovePostData } = data;
    if (postBindCohortCommentRemovePostData) {
      dispatch({
        type: COHORTS_COMMENT_REMOVE_POST,
        payload: postBindCohortCommentRemovePostData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortCommentRemovePost(params) {

  const postBindCohortCommentRemovePostData =
  await MentorServices.postCohortCommentRemoveAPI (params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortCommentRemovePostData,
  };
}


export const cohortCommentReplyPost = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCommentReplyPost(params).then((data) => {
    const { postBindCohortCommentReplyPostData } = data;
    if (postBindCohortCommentReplyPostData) {
      dispatch({
        type: COHORTS_COMMENT_REPLY_POST,
        payload: postBindCohortCommentReplyPostData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCommentReplyPost(params) {

  const postBindCohortCommentReplyPostData =
  await MentorServices.postCohortCommentReplyAPI (params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortCommentReplyPostData,
  };
}



export const cohortCommentReplyList = (params,cohort_name) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortCommentReplyList(params).then((data) => {
    const { postBindCohortCommentReplyListData } = data;
    if (postBindCohortCommentReplyListData) {
      dispatch({
        type: COHORTS_COMMENT_REPLY_LIST,
        payload: postBindCohortCommentReplyListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortCommentReplyList(params) {

  const postBindCohortCommentReplyListData =
  await MentorServices.postCohortCommentReplyListAPI (params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortCommentReplyListData,
  };
}


export const postCohortDiscussionActivity = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortDiscussionActivity(params).then((data) => {
    const { postCohortDiscussionActivityData } = data;
    
    if (postCohortDiscussionActivityData) {
      dispatch({
        type: COHORT_DASHBOARD_ACTIVITY,
        payload: postCohortDiscussionActivityData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortDiscussionActivity(params) {

  const postCohortDiscussionActivityData =
  await MentorServices.postCohortDashboardActivityAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postCohortDiscussionActivityData,
  };
}



export const postCohortMentorListCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortMentorListCounter(params).then((data) => {
    const { postBindCohortMentorListCounterData } = data;
    
    if (postBindCohortMentorListCounterData) {
      dispatch({
        type: COHORT_DASHBOARD_MENTORS_COUNTER,
        payload: postBindCohortMentorListCounterData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortMentorListCounter(params) {

  const postBindCohortMentorListCounterData =
  await MentorServices.postCohortDashboardMentorCounterAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortMentorListCounterData,
  };
}




export const postCohortStartupListCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindCohortStartupListCounter(params).then((data) => {
    const { postBindCohortStartupListCounterData } = data;
    
    if (postBindCohortStartupListCounterData) {
      dispatch({
        type: COHORT_DASHBOARD_STARTUP_COUNTER,
        payload: postBindCohortStartupListCounterData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindCohortStartupListCounter(params) {

  const postBindCohortStartupListCounterData =
  await MentorServices.postCohortDashboardStartupCounterAPI(params).catch((e) => {
    return { data: [], status: false };
  });
return {
  postBindCohortStartupListCounterData,
  };
}